import React from 'react';

//styling
import './InputList.css';

const InputList = (props) => {
    const {
        currentQuestion,
        questionAnswerOptions,
        onButtonOptionClicked,
        onCustomQuestionAnswerClicked
    } = props;

    return (<div>{
        questionAnswerOptions.map((option, key) => { 
          if(currentQuestion.customQuestion && currentQuestion.customQuestion === true) { 
            return <div key={key} className="answerOptions" onClick={()=>onCustomQuestionAnswerClicked(option)}>{option}</div> 
          } else {
            return <div key={key} className="answerOptions" onClick={()=>onButtonOptionClicked(option)}>{option}</div> 
          }
        })
      }</div>);
}

export default InputList;